import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import DashboardHeader from "./DashboardHeader";
import Marketing from "./Marketing";
import Announcements from "./Announcements";
import { getSubmittedAppsByDealer } from "api/AppTrackerAPI";
import LoansTable from "features/loanManager/compontents/LoansTable";
import { useFromUser } from "stores/LocalStorageHelper";
import { PATHS } from "constants/Constants";

/**
 * Dashboard component - the main component for the dashboard page
 * @returns {JSX.Element} - Rendered Dashboard component
 */
const Dashboard = () => {
	const history = useHistory();

	// Local state to hold fetched loans data
	const [loansData, setLoansData] = useState([]);

	const dealerID = useFromUser("dealerID");
	const locationID = useFromUser("locationID");
	console.log("dealerID:", dealerID);
	console.log("locationID:", locationID);
	const compositeId = `${dealerID ?? ""}${locationID ?? ""}`;

	console.log("compositeId:", compositeId);

	// Check if all required sessionStorage data exists
	useEffect(() => {
		const requiredKeys = [
			"tecAssuredVehicleTypes",
			"dealerPartnerSend",
			"dealerPartnerLink",
			"digitzsMerchant",
			"dealersList",
			"formsReports",
			"makes",
			"models",
			"inventoryDefaults",
		];

		const missingKeys = requiredKeys.filter(
			(key) => !sessionStorage.getItem(key)
		);

		// If any required data is missing, redirect to data loading screen
		if (missingKeys.length > 0) {
			console.warn(
				"Missing required dashboard data, redirecting to data loading:",
				missingKeys
			);
			history.push(PATHS.DATA_LOADING);
		}
	}, [history]);

	// Fetch loans once we have a valid composite ID
	useEffect(() => {
		if (!dealerID || !locationID) return;

		// Fetch the submitted apps using our composite ID
		getSubmittedAppsByDealer(compositeId)
			.then((data) => {
				// Update state with the array of loan applications
				setLoansData(data);
				console.log("data:", data);
			})
			.catch((err) => {
				console.error(
					`[LenderIntegrations] failed to fetch loans for ID ${compositeId}:`,
					err
				);
				setLoansData([]); // Explicitly set to empty array on failure
			});
	}, [dealerID, locationID, compositeId]);

	return (
		<div className="content">
			<DashboardHeader />
			<Announcements />
			<LoansTable data={loansData} />
			<Marketing />
		</div>
	);
};

export default Dashboard;
